module.exports = __webpack_public_path__ + "static/img/2.4961506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.jpg
// module id = AsW3
// module chunks = 10